import React from "react";
import DossierActions from "../redux/DossierRedux";
import { connect } from "react-redux";
//import HeaderForm from "../components/HeaderForm/HeaderForm";

import Layout from "../components/Layout";

class LienDossierPage extends React.Component {

    constructor(props) {
        super(props);

        let id = this.props.match.params.id;

        if (id != null) {
            this.props.reset();
            this.props.goGetDossier(id);
            this.state = { id: id };
        } else {
            this.state = {};
        }
    }

    render() {
        return (
            <Layout>
                {this.props.error &&
                    <div><br /><br /><h3>Dossier {this.props.match.params.id} non trouvé</h3><br /><br /></div>
                }
            </Layout>
        );
    }


    static getDerivedStateFromProps = (nextProps, prevState) => {
        if (nextProps.dossier !== null) {
            console.log('found dossier ' + nextProps.dossier.email);
            nextProps.history.replace("/nouveau-dossier");
        }
        return nextProps;
    };

}


const mapStateToProps = (state) => {
    return {
        dossier: state.dossiers.dossier,
        isFetching: state.dossiers.fetching,
        error: state.dossiers.error,
        errorMessage: state.dossiers.errorMessage,
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        goGetDossier: (id) => dispatch(DossierActions.getDossier(id)),
        reset: () => dispatch(DossierActions.dossierFailure())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LienDossierPage);
